import React from 'react';
import {
    Briefcase, CheckCircle, XCircle, Clock, DollarSign,
    AlertTriangle, Trophy, Star, TrendingUp, Activity
} from 'lucide-react';

const iconMap = {
    briefcase: Briefcase,
    check: CheckCircle,
    cancel: XCircle,
    clock: Clock,
    dollar: DollarSign,
    alert: AlertTriangle,
    trophy: Trophy,
    star: Star,
    trend: TrendingUp,
    activity: Activity,
};

const colorMap = {
    blue: 'bg-blue-100 text-blue-700',
    green: 'bg-green-100 text-green-700',
    red: 'bg-red-100 text-red-700',
    amber: 'bg-amber-100 text-amber-700',
    purple: 'bg-purple-100 text-purple-700',
    cyan: 'bg-cyan-100 text-cyan-700',
};

const KpiCard = ({ title, value, subtitle, icon = 'activity', color = 'blue' }) => {
    const Icon = iconMap[icon] || Activity;
    const colorClass = colorMap[color] || colorMap.blue;

    return (
        <div className="bg-white rounded-lg border border-gray-200 p-4 md:p-5 shadow-sm">
            <div className="flex items-start gap-3">
                <div className={`p-2.5 rounded-lg shrink-0 ${colorClass}`}>
                    <Icon className="w-5 h-5" />
                </div>
                <div className="min-w-0 flex-1">
                    <p className="text-xs md:text-sm font-medium text-gray-500 truncate">{title}</p>
                    <p className="text-xl md:text-2xl font-bold text-gray-900 mt-0.5 break-words">{value}</p>
                    {subtitle ? (
                        <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default KpiCard;
